import GradeLessonPage from '../components/GradeLessonPage';
import { apCalcABData } from './data';

export default function APCalcABPage() {
  return (
    <GradeLessonPage
      grade="ap-calc-ab"
      gradeLabel="AP Calculus AB"
      gradeColor="amber"
      topics={apCalcABData}
      prevGrade={{ label: 'Pre-Calculus', path: '/precalc' }}
      nextGrade={{ label: 'AP Calculus BC', path: '/ap-calc-bc' }}
    />
  );
}
